<div class="info-note-box shadow-sm mb-3">
    <i class="fas fa-info-circle info-note-icon"></i>
    <div>Remark : If you would like to stay at {{ event.location }} with special group rate, please follow the link below to make a reservation with hotel directly.</div>
</div>
 <div class="mb-3 p-3 rounded border bg-white shadow-sm">
    <h5 class="mb-1">{{ event.location }}</h5>
    <a id="investor-hotel-reservation-link" class="link-blue" target="_blank" href="https://www.marriott.com/events/start.mi?id=1716519936463&key=GRP">
    Hotel reservation link
    </a>
 </div>